/* unplugin-vue-components disabled */
import {markRaw} from 'vue'
import {TopicSearch} from 'components/search-dropdown'
import TrackerSegment from './tracker-segment.vue'
import TrackerButtongroup from './tracker-buttongroup.vue'
import TrackerTextarea from './tracker-textarea.vue'
import {TOPIC_ALERTS, TOPIC_SENSITIVITY} from 'consts/tracker'
import $topics from 'stores/topics2'

export default {
  components: {TopicSearch, TrackerSegment, TrackerButtongroup, TrackerTextarea},
  data() {
    return {
      topic: undefined,
      tracker_focus: 'balanced',
      tracker_alerts: 'all',
      focus_on: '',
      saving: false,
      SENSITIVITY: markRaw(TOPIC_SENSITIVITY),
      ALERTS: markRaw(TOPIC_ALERTS)
    }
  },
  computed: {
    can_save() {
      return !!this.topic?.shared_topic_id
    },
    tracker_data() {
      return {
        shared_topic_id: this.topic?.shared_topic_id,
        tracker_focus: this.tracker_focus,
        tracker_alerts: this.tracker_alerts,
        focus_on: this.focus_on.trim()
      }
    }
  },
  mounted() {
    this.$refs.topic.focus()
  },
  beforeUnmount() {
    this.$refs.topic?.abortAll()
  },
  methods: {
    async onSave() {
      const data = this.tracker_data
      this.saving = true
      try {
        const topic = await $topics.newTopic(data)
        this.$dispatch('edit-topic', {topic_id: topic.id})
        this.$dispatch('save', data)
      } catch (err) {
        if (err.http_code === 409) {
          $utils.toasts.success('You are already tracking this topic.')
          return
        }
        $utils.toasts.error('Failed to track this topic. Please try again.')
      } finally {
        this.saving = false
      }
    }
  }
}
